























































import Vue, { PropType } from 'vue';
import { FirestoreDate } from '@/modules/firestore';
// import { formatContactListDate } from '@/modules/calender';
import { calender } from 'mostra';

export default Vue.extend({
  name: 'GChatBrandListItem',
  props: {
    name: { type: String as PropType<string>, default: '' },
    brand: { type: String as PropType<string>, default: '' },
    brandLogoSrc: { type: String as PropType<string>, default: null },
    brandImageSrc: { type: String as PropType<string>, default: null },
    avatar: {
      type: String as PropType<string>,
      default: null,
    },
    company: {
      type: String as PropType<string>,
      default: '',
    },
    date: {
      type: [Date, Object] as PropType<FirestoreDate>,
    },
    latestMessageText: {
      type: String as PropType<string>,
      default: '',
    },
    latestMessageWithUrl: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    latestMessageWithAttachment: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    unseen: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    unreplied: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      displayDate: calender.formatContactListDate(this.date),
    };
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
});
